import React, { useState, useEffect } from "react";
import Card from "../reusable/Card";
import ProfileIconB from "../../assets/icons/profile_icon_b.svg";
import fox from "../../assets/icons/fox.svg";
import connectionDisconnected from "../../assets/icons/signal_disconnected.svg";
import { useConnectWallet, useWallets, useSetChain } from "@web3-onboard/react";
import { ethers } from "ethers";
import CopyToClipboard from "./components/CopyToClipboard";



function ProfileDetails() {
  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
  const [balance, setBalance] = useState(0);
  const [coinTicker, setCoinTicker] = useState("");
  const [{ chains, connectedChain, settingChain }, setChain] = useSetChain();

  async function getTokenTicker() {
    if (wallet) {
      try {
        // console.log(connectedChain.id);
        switch ((connectedChain.id).toString()) {
          case "0x89": setCoinTicker("POL");
            break;
          case '0x38': setCoinTicker("BNB");
            break;
          case '0x1': setCoinTicker("ETH");
            break;
          case '0x1530': setCoinTicker("EDX");
            break;
        }
      } catch (error) {
        //  console.log(error) 
      }
    }
  }
  async function getETHBalance() {
    try {
      if (wallet?.accounts[0]?.address) {
        const provider = new ethers.providers.Web3Provider(
          wallet?.provider,
          "any"
        );
        const balance = await provider.getBalance(wallet?.accounts[0]?.address);
        setBalance(ethers.utils.formatEther(balance).slice(0, 5));
      }
    } catch (e) {
      //  console.log(e)
    }

  }
  useEffect(() => {
    getETHBalance();
    getTokenTicker();
  }, [wallet, connectedChain]);


  return (
    <Card
      onClick={(event) => {
        event.stopPropagation();
      }}
      className=" absolute top-12 z-[999] right-1 gap-8 flex flex-col justify-between rounded-lg p-5 "
    >
      <div className="flex gap-5 py-5 border-b border-solid border-dark-border ">
        {/* <img src={ProfileIconB} alt="profile"></img> */}
        <div className="w-12 relative ">
          <img className="" src={ProfileIconB} alt="profile"></img>
          {wallet?.label == "MetaMask" && <div className="p-1 rounded-full z-50 absolute -top-[.1rem] right-[0rem] bg-sunny-secondary">
            <img src={fox} alt="fox" />
          </div>}
        </div>
        <div className=" ">
          <p className="">{wallet && wallet.label}</p>
          <div className="flex justify-between">
            <p className="font-thin">
              {wallet && wallet.accounts && wallet.accounts.length > 0 ? (
                <>
                  {wallet.accounts[0].address.slice(0, 8)}...
                  {wallet.accounts[0].address.slice(-8)}
                </>
              ) : (
                "No wallet connected"
              )}
            </p><>&nbsp;</>
            <CopyToClipboard
              walletAddress={
                wallet
                  ? wallet.accounts
                    ? wallet.accounts[0].address
                      ? wallet.accounts[0].address
                      : "none"
                    : "none"
                  : "none"
              }
            />
          </div>
        </div>
      </div>
      <p className="flex justify-center">{balance} {coinTicker}</p>
      <div className="flex justify-center  text-sm">
        <div className="dark:bg-dark-secondary flex justify-center px-2 py-3">
          <img src={connectionDisconnected} alt="Disconnected"></img>
          <button
            className="ml-4"
            onClick={() => disconnect({ label: wallet.label })}
            style={{
              cursor: "pointer", // Hand cursor on hover
              border: "1px solid transparent", // Initial border
              padding: "5px 8px",
              transition: "border-color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#ccc")} // Light border on hover
            onMouseLeave={(e) =>
              (e.currentTarget.style.borderColor = "transparent")
            } // Reset border on mouse leave
          >
            Disconnect
          </button>
        </div>
      </div>
    </Card>
  );
}

export default ProfileDetails;
